export const STORE_KEY = 'gic-smart-fields-feature';
